import { render, staticRenderFns } from "./autobackup.vue?vue&type=template&id=f1293aec&"
import script from "./autobackup.vue?vue&type=script&lang=ts&"
export * from "./autobackup.vue?vue&type=script&lang=ts&"
import style0 from "./autobackup.vue?vue&type=style&index=0&id=f1293aec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports